import React from "react";
import "./ArticlePreviewGalleryItem.css";
import ReactHtmlParser from "react-html-parser";
import { ACDTYPE_VIDEO } from "../../model/ACDTypes";
import {
  setPreviewingTextLineIDs,
  setPreviewingImageIDs,
  setPreviewingItemHidingMode
} from "../../redux/actions/editArticlePanel";
import { connect } from "react-redux";
import { combineTextLineIDs } from "../../model/privateACDType";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";

class ArticlePreviewGalleryItem extends React.Component {
  constructor(props) {
    super(props);
    this.onHover = this.onHover.bind(this);
    this.onInvisibleClicked = this.onInvisibleClicked.bind(this);
    this.onHighlightClicked = this.onHighlightClicked.bind(this);
  }

  onHover(hovering) {
    const {
      item,
      setPreviewingTextLineIDs,
      setPreviewingImageIDs
    } = this.props;

    if (hovering) {
      const reducer = (accumulator, currentValue) =>
        combineTextLineIDs(accumulator, currentValue.textLineIDs);
      const allTextLineIDs = item.imageItemArr.reduce(
        reducer,
        item.textLineIDs
      );
      const allImageIDs = item.imageItemArr.map(item => item.image.id);

      setPreviewingTextLineIDs({ textLineIDs: allTextLineIDs });
      setPreviewingImageIDs({ imageIDs: allImageIDs });
    } else {
      setPreviewingTextLineIDs({ textLineIDs: null });
      setPreviewingImageIDs({ imageIDs: null });
    }
  }

  onInvisibleClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "invisible") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "invisible" });
    }
  }

  onHighlightClicked() {
    const { mode, item, setPreviewingItemHidingMode } = this.props;

    if (mode === "highlight") {
      setPreviewingItemHidingMode({ id: item.id, mode: null });
    } else {
      setPreviewingItemHidingMode({ id: item.id, mode: "highlight" });
    }
  }

  render() {
    const { item, mode } = this.props;
    const { imageItemArr } = item;

    if (imageItemArr == null || imageItemArr.length <= 0) {
      return null;
    }

    const reducer = (accumulator, currentValue) => {
      return (
        (currentValue.text != null && currentValue.text !== "") || accumulator
      );
    };

    const hasIndivisualCaption = imageItemArr.reduce(reducer, false);

    const h = hasIndivisualCaption ? "169pt" : "150pt";

    return (
      <div style={{ position: "relative", paddingTop: "20pt" }}>
        <div
          onMouseEnter={() => this.onHover(true)}
          onMouseLeave={() => this.onHover(false)}
        >
          <div
            className="article_preview_gallery_container"
            style={{ height: h }}
          >
            {imageItemArr.map(anImageItem => {
              if (anImageItem.dataType === ACDTYPE_VIDEO) {
                const imgUri = `${process.env.REACT_APP_API_ROOT}artworks/${
                  anImageItem.media.thumbnail.id
                }/static`;
                const videoUri = `${process.env.REACT_APP_API_ROOT}videos/${
                  anImageItem.media.id
                }/playback`;

                return (
                  <div
                    key={anImageItem.id}
                    className="article_gallery_image_container"
                  >
                    <video
                      className="article_gallery_video"
                      controls
                      poster={imgUri}
                    >
                      <source src={videoUri} type="video/mp4" />
                    </video>
                    {anImageItem.text != null && anImageItem.text !== "" && (
                      <span className="article_preview_gallery_image_caption">
                        {ReactHtmlParser(
                          anImageItem.text.replace(/\n/g, "<br>")
                        )}
                      </span>
                    )}
                  </div>
                );
              } else {
                const imgUri = `${process.env.REACT_APP_API_ROOT}artworks/${
                  anImageItem.image.id
                }/static`;
                return (
                  <div
                    key={anImageItem.id}
                    className="article_gallery_image_container"
                  >
                    <img
                      className="article_gallery_image"
                      alt={anImageItem.text}
                      src={imgUri}
                    />
                    {anImageItem.text != null && anImageItem.text !== "" && (
                      <span className="article_preview_gallery_image_caption">
                        {ReactHtmlParser(
                          anImageItem.text.replace(/\n/g, "<br>")
                        )}
                      </span>
                    )}
                  </div>
                );
              }
            })}
          </div>
          {item.text != null && item.text !== "" && (
            <div>
              <hr className="article_preview_gallery_sep" />
              <span className="article_preview_gallery_caption">
                {ReactHtmlParser(item.text.replace(/\n/g, "<br>"))}
              </span>
            </div>
          )}
        </div>
        <ButtonGroup
          style={{ position: "absolute", top: "20pt", right: "-70px" }}
          size="sm"
        >
          <Button
            variant={mode === "invisible" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onInvisibleClicked}
          >
            <span className="fa fa-eye-slash" />
          </Button>
          <Button
            variant={mode === "highlight" ? "dark" : "secondary"}
            style={{ margin: 0 }}
            onClick={this.onHighlightClicked}
          >
            <span className="fa fa-language" />
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

const mapDispatch = {
  setPreviewingTextLineIDs,
  setPreviewingImageIDs,
  setPreviewingItemHidingMode
};

const mapState = (state, ownProps) => {
  const { editArticlePanel } = state;
  const { previewHidingItemIDs } = editArticlePanel;

  return {
    mode: previewHidingItemIDs[ownProps.item.id]
  };
};

export default connect(
  mapState,
  mapDispatch
)(ArticlePreviewGalleryItem);
